<mat-drawer-container class="main-container" style="background-color: white;" autosize>
    <mat-drawer #drawer class="sidenav-drawer" class="drawer-style" mode="side" opened>
        <div class="mt-40">
        </div>
    </mat-drawer>
    <mat-drawer-content class="overflow-hidden">
        <div class="sidenav-content">

            <div class="row col-12 m-0 centerAlign">
                <div class="col-5 mt-5">
                    <div class="entityDet-title">
                        <form class="w-100" [formGroup]="userMapUpdateForm" autocomplete="off" novalidate
                            (ngSubmit)="updateUsermapping(userMapUpdateForm.value)">
                            <h2 class="justify-content-center d-flex w-100 fontweighthead">User Mapping</h2>
                            <div *ngIf="showError" class="alert alert-danger" role="alert">
                                {{errorMessage}}
                            </div>                    
                            <div *ngIf="showSuccess" class="alert alert-success" role="alert">
                                {{successMessage}}
                            </div>


                            <div class="row py-2" style="height:35px">   
                                <label for="email" class="fontweightlabel col-md-3 pt-2" style="display: flex;justify-content: left;align-items: center;">Email:</label>
                                <input type="text" id="email" formControlName="email" [(ngModel)]="cognitoUserEmail" 
                                style="pointer-events: none !important;opacity: 0.6;"
                                class="form-control col-md-8" />                       
                            </div>
                            <div class="row py-2" style="height:35px">   
                                <label for="org" class="fontweightlabel col-md-3 pt-2" style="display: flex;justify-content: left;align-items: center;">Organization:</label>
                                <input type="text" id="org" formControlName="org" [(ngModel)]="userOrgName"
                                style="pointer-events: none !important;opacity: 0.6;"
                                class="form-control col-md-8" />                       
                            </div>

                            <div class="row py-2" style="height:35px">               
                                <label for="grp" class="fontweightlabel col-md-3 pt-2" style="display: flex;justify-content: left;align-items: center;">Group:</label>
                                <select id="grp" formControlName="grp" class="form-control col-md-8 m-0 p-2"  [(ngModel)]="userGrpId">
                                    <option *ngFor="let group of masterGroups"value={{group.groupId}}>{{group.groupName}}</option>
                                </select>
                            </div>  
                             <div class="col-md-5">
                                <em *ngIf="validateControl('grp') && hasError('grp', 'required')">Group is required</em>
                            </div> 


                            <div class="row py-2" style="height:30px">                   
                                <label for="grp" class="fontweightlabel col-md-3 pt-2" style="display: flex;justify-content: left;align-items: center;">Role:</label>
                                <select id="role" formControlName="role" class="form-control col-md-8 m-0 p-2"  [(ngModel)]="userRoleId">
                                    <option *ngFor="let role of masterRoles" value={{role.userTypeId}}>{{role.userTypeDesc}}</option>
                                </select>
                            </div>  
                             <div class="col-md-5">
                                <em *ngIf="validateControl('role') && hasError('role', 'required')">Role is required</em>
                            </div>  
                            <br>








     



                            <div class="button-row mt-4">                               
                                    <button class="col-md-12 buttonstyle"
                                    [disabled]="!userMapUpdateForm.valid"
                                     mat-raised-button >Update</button>
                                     <button  class="col-md-12 mt-2 buttonstyle"                                   
                                     mat-raised-button  (click)="cancel()">Cancel</button>
                            </div>
                        </form>
                    </div>

                </div>
                <div class="col-4  mt-5">
                    <img class="pl-3" src="/assets/images/SI4.png" style="width: 500px; height: 300px;" alt="Portal logo">
                </div>
            </div>

        </div>
    </mat-drawer-content>
</mat-drawer-container>